import { SensorType } from '@thingslog/repositories';

export const sensorTypeOptions: Record<SensorType, string> = {
  barometric_pressure_sensor: 'barometric_pressure_sensor',
  dew_point_sensor: 'dew_point_sensor',
  humidity_sensor: 'humidity_sensor',
  level_sensor: 'level_sensor',
  load_cells: 'load_cells',
  modbus_generic_analog_sensor: 'modbus_generic_analog_sensor',
  particulate_matter_sensor: 'particulate_matter_sensor',
  generic_analog_sensor: 'generic_analog_sensor',
  generic_virtual_sensor: 'generic_virtual_sensor',
  leaf_wetness_sensor: 'leaf_wetness_sensor',
  gnss_sensor: 'gnss_sensor',
  co_sensor: 'co_sensor',
  no2_sensor: 'no2_sensor',
  so2_sensor: 'so2_sensor',
  tasmota_generic_analog_sensor: 'tasmota_generic_analog_sensor',
  pressure_sensor: 'pressure_sensor',
  soil_moisture_sensor: 'soil_moisture_sensor',
  soil_potential_sensor: 'soil_potential_sensor',
  soil_temperature_sensor: 'soil_temperature_sensor',
  temperature_sensor: 'temperature_sensor',
  weight_meter: 'weight_meter',
  weight_sensor: 'weight_sensor',
  wind_direction_sensor: 'wind_direction_sensor',
  wind_speed_sensor: 'wind_speed_sensor',
  gas_flow_meter: 'gas_flow_meter',
  geiger_mueller_counter: 'geiger_mueller_counter',
  heat_meter: 'heat_meter',
  modbus_generic_digital_sensor: 'modbus_generic_digital_sensor',
  power_meter: 'power_meter',
  rain_sensor: 'rain_sensor',
  water_meter: 'water_meter',
  tasmota_generic_digital_sensor: 'tasmota_generic_digital_sensor',
  generic_digital_sensor: 'generic_digital_sensor',
  on_off_sensor: 'on_off_sensor',
  on_off_input_sensor: 'on_off_input_sensor',
  on_off_output_sensor: 'on_off_output_sensor',
  on_off_auto_output_sensor: 'on_off_auto_output_sensor',
  modbus_generic_on_off_output_sensor: 'modbus_generic_on_off_output_sensor',
  modbus_generic_on_off_input_sensor: 'modbus_generic_on_off_input_sensor',
  tasmota_relay_sensor: 'tasmota_relay_sensor',
  tasmota_alarm_input_sensor: 'tasmota_alarm_input_sensor',
};
